module.exports = __webpack_public_path__ + "img/地图.f51a3137.jpg";